import useSave from "./useSave";
import useSendTestEmail from "./useSendTestEmail";

export default () => {
  const { save, saveAndClose } = useSave();
  const { sendTestEmail } = useSendTestEmail();

  return {
    save,
    saveAndClose,
    sendTestEmail,
  };
};
